import React from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import './styles.css';

const iconLeft = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="31"
    height="15"
  >
    <image
      data-name="arrow-left"
      width="31"
      height="15"
      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAPCAMAAAArpuSQAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAXVBMVEUnKC3///8nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0AAAAkjsACAAAAHXRSTlMAAFS4A4fZKhK6sxAv3YABWuZOBI/WJiS/rQ3jFR6wDRMAAAABYktHRB5yCiArAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4wILCzQVK2fvEAAAAFRJREFUGNNjYIACJmYIzYgKoLIsrGzseOQ5OLm4GXDL8/Dy8TPglhcQFGJgwCkvLCIqxoBbXlxCUooBj7y0LF7AIENAPyH7CbqfsP8Jhh/B8McdfwC8jQcVo9prRQAAAABJRU5ErkJggg=="
    />
  </svg>
);

const iconRight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="31"
    height="15"
  >
    <image
      data-name="arrow-right"
      width="31"
      height="15"
      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAPCAMAAAArpuSQAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAXVBMVEUnKC3///8nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0nKC0AAAAkjsACAAAAHXRSTlMAALhUKtmHAxCzuhIBgN0vTuZaJtaPBA2tvyTjFZHxbcUAAAABYktHRB5yCiArAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4wILCzQ2iQCeYgAAAFRJREFUGNNjYEADjCDAxMwIBQxY5VlY2djxyTNycHJx45Nn5OHl48cnz8goICiEV55RWERUDJ88o7iEpBSDLF4gTUC/DPn243c/Af8TCD9C4Y+IPwBPbgbgJFmHIQAAAABJRU5ErkJggg=="
    />
  </svg>
);

const iconLeftSmall = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="30 25 700 700"
    width="20"
    height="25"
  >
    <path d="M97.141 225.92c0-8.095 3.091-16.192 9.259-22.366L300.689 9.27c12.359-12.359 32.397-12.359 44.751 0 12.354 12.354 12.354 32.388 0 44.748L173.525 225.92l171.903 171.909c12.354 12.354 12.354 32.391 0 44.744-12.354 12.365-32.386 12.365-44.745 0l-194.29-194.281c-6.167-6.177-9.252-14.274-9.252-22.372z" />
  </svg>
);

const iconRightSmall = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="20 25 700 700"
    width="20"
    height="25"
  >
    <path d="M345.441 248.292L151.154 442.573c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744L278.318 225.92 106.409 54.017c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.287 194.284c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z" />
  </svg>
);

const BasicPagination = props => {
  const {
    page,
    smallIcons,
    perPage,
    count,
    pageRangeDisplayed,
    controlFunc,
  } = props;
  const activePage = parseInt(page) + 1;

  const changePageHandler = pageNumber => {
    controlFunc(pageNumber - 1);
  };

  return (
    <div className="pagination__wrapper">
      <Pagination
        innerClass="pagination"
        itemClass="pagination__item"
        activeClass="pagination__item--active"
        disabledClass="pagination__item--disabled"
        linkClass="pagination__item-link"
        activeLinkClass="pagination__item-link--active"
        itemClassPrev="pagination__item--prev"
        itemClassNext="pagination__item--next"
        prevPageText={
          <span className="pagination__icon pagination__icon-left">
            {smallIcons ? iconLeftSmall : iconLeft}
          </span>
        }
        nextPageText={
          <span className="pagination__icon pagination__icon-right">
            {smallIcons ? iconRightSmall : iconRight}
          </span>
        }
        activePage={activePage}
        itemsCountPerPage={perPage}
        totalItemsCount={count}
        pageRangeDisplayed={pageRangeDisplayed}
        onChange={changePageHandler}
        hideFirstLastPages
      />
    </div>
  );
};

BasicPagination.propTypes = {
  page: PropTypes.number.isRequired,
  smallIcons: PropTypes.bool,
  perPage: PropTypes.number.isRequired,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  pageRangeDisplayed: PropTypes.number.isRequired,
  controlFunc: PropTypes.func.isRequired,
};

export default BasicPagination;
